import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as idcFunctionSpace from '../../idc-function-space'

export const RESOURCE = {
  payload: {
    description:
      'A classification of building spaces for operations and maintenance cost allocation.',
    dimension: idcFunctionSpace.RESOURCE.payload,
    level: 0,
    name: 'O&M Subcategory Building Assignment',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
